module.exports = __webpack_public_path__ + "media/icons/sort_asc-ad926b2c.svg";